{
  "removeButtonLabel": "Eemalda",
  "removeDescription": "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
}
